import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import getMisNotificaciones from "../../services/Notificaciones/getMisNotificaciones";

const initialState = {
  notifs: [],
  isLoading: true,
};

export const buscarNotifs = createAsyncThunk(
  "notifs/buscar",
  async (_, thunkAPI) => {
    try {
      const response = await getMisNotificaciones();
      if (response?.error) return initialState;
      return response;
    } catch (error) {
      console.error("Error al obtener notificaciones:", error);
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const updateNotif = createAsyncThunk(
  "notifs/updateConfirmacion",
  async (arrNotifs, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const { currentUser } = state.auth;
      if (!currentUser) {
        return {
          ...initialState,
          isLoading: false,
        };
      }
      let filteredArr = arrNotifs.filter(
        (notif) => notif.miEstadoNotif === "R" && notif.estado === "A",
      );
      return filteredArr;
    } catch (error) {
      console.error("Error al obtener notificaciones:", error);
      return thunkAPI.rejectWithValue(error);
    }
  },
);

const notifsSlice = createSlice({
  name: "notifs",
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(buscarNotifs.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(buscarNotifs.fulfilled, (state, { payload }) => {
        state.notifs = payload;
        state.isLoading = false;
      })
      .addCase(buscarNotifs.rejected, (state, action) => {
        console.error("Error en la carga de las notifs:", action.payload);
      })
      .addCase(updateNotif.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateNotif.fulfilled, (state, { payload }) => {
        state.notifs = payload;
        state.isLoading = false;
      })
      .addCase(updateNotif.rejected, (state, action) => {
        console.error("Error en el update de las notifs:", action.payload);
        state.isLoading = false;
      }),
});

export default notifsSlice.reducer;
